import { DateTime } from 'luxon';

export function formatDateTime(dateTimeString: string) {
  if (!dateTimeString) return 'Date not currently available.';
  const dateTime = DateTime.fromISO(dateTimeString);
  const formattedDateTime = dateTime.toFormat('LLL dd, yyyy @ hh:mm a');

  return formattedDateTime;
}
